import { Injectable } from "@angular/core";
import { ConfigurationResource } from "core/stages-client";

@Injectable({ providedIn: "root" })
export class ConfigurationService {
	private urlAllowedProtocols?: stages.configurationservice.ConfigurationResourceAllowedURLProtocols;

	constructor(private configurationResource: ConfigurationResource) {}

	async getURLAllowedProtocolsProperty(): Promise<stages.configurationservice.ConfigurationResourceAllowedURLProtocols> {
		return this.urlAllowedProtocols ? this.urlAllowedProtocols : this.getURLAllowedProtocolsPropertyForceUpdated();
	}

	async getURLAllowedProtocolsPropertyForceUpdated(): Promise<stages.configurationservice.ConfigurationResourceAllowedURLProtocols> {
		this.urlAllowedProtocols = await this.configurationResource.getURLAllowedProtocols();
		return this.urlAllowedProtocols;
	}
}
